import type { SxProps, Theme } from "@mui/material";

/**
 * Shared reading width for every Component pane.
 *
 * The panes used to cap at 480-720px, which left the editor's right half empty
 * under the full-width live preview and squeezed card content into a column
 * narrower than the thing it was describing. Wide enough to breathe, still
 * short of the full viewport so text lines stay readable.
 */
export const EDITOR_MAX_WIDTH = 1080;

/**
 * Responsive field grid for template editor panes. Instead of a single narrow
 * column that leaves the right half of the editor empty under the live preview,
 * fields/cards tile across the full available width while each cell keeps a
 * readable minimum width (they collapse to one column on narrow screens).
 *
 * Pass a `min` to tune the readable column width per pane (wider for cards with
 * previews, narrower for compact rows).
 */
export function fieldGrid(min = 260): SxProps<Theme> {
  return {
    display: "grid",
    gridTemplateColumns: `repeat(auto-fill, minmax(${min}px, 1fr))`,
    gap: 2,
    alignItems: "start",
  };
}
